import moment from 'moment';
import { useRouter } from 'next/router';

const SidebarRight = ({ date, handleChangeDate, currentDate }) => {
  const router = useRouter();
  return (
    <div>
      {moment(date).format('YYYY-MM-DD') ===
        moment(currentDate).format('YYYY-MM-DD') ? (
        <button
          className="btn date-btn btn-active"
          style={{
            width: '100%'
          }}
          onClick={() => handleChangeDate(date)}
        >
          <p className="color-light-blue">{moment(date).format('ddd')}</p>
          <h5>{moment(date).format('DD')}</h5>
          <p className="color-light-blue">{moment(date).format('MMM')}</p>
        </button>
      ) : (
        <button className="btn date-btn" style={{
          width: '100%'
        }} onClick={() => handleChangeDate(date)}>
          <p>{moment(date).format('ddd')}</p>
          <h5>{moment(date).format('DD')}</h5>
          <p>{moment(date).format('MMM')}</p>
        </button>
      )}
    </div>
  );
};

export default SidebarRight;
